import axios from 'axios'

function isInstalledPwa() {
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
}

function deviceFingerprint() {
  let fingerprint = localStorage.getItem('mel_device_fingerprint')

  if (!fingerprint) {
    fingerprint = `${Date.now()}-${Math.random().toString(36).slice(2)}`
    localStorage.setItem('mel_device_fingerprint', fingerprint)
  }

  return fingerprint
}

export async function registerPwaInstallation(apiBase, appName = 'melcaisse') {
  const token = localStorage.getItem('jwtToken')

  if (!token || !isInstalledPwa()) {
    return
  }

  await axios.post(`${apiBase}pwa-installations`, {
    app: appName,
    device_fingerprint: deviceFingerprint(),
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}
